import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ImageUpload from "@/components/ImageUpload";

export default function Register() {
  const navigate = useNavigate();
  const { applyLogin } = useAuth();
  const [form, setForm] = useState({ display_name: "", email: "", password: "", avatar: null });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (form.display_name.trim().length < 2) {
      setError("Bitte gib einen Anzeigenamen mit mindestens 2 Zeichen ein.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      setError("Bitte eine gültige E-Mail-Adresse eingeben.");
      return;
    }
    if (form.password.length < 12) {
      setError("Das Passwort braucht mindestens 12 Zeichen.");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/register", form);
      applyLogin(data);
      navigate("/profil");
    } catch (e) {
      setError(errMsg(e, "Registrierung nicht möglich."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-5 py-14">
      <h1 className="text-4xl">Konto anlegen</h1>
      <p className="mt-2 text-sm text-[var(--ink-soft)]">Wir brauchen nur einen Namen, eine E-Mail und ein Passwort.</p>
      <form onSubmit={submit} className="mt-8 space-y-4" data-testid="register-form">
        <div>
          <div className="eyebrow mb-1">Anzeigename</div>
          <input
            className="field"
            value={form.display_name}
            onChange={(e) => setForm({ ...form, display_name: e.target.value })}
            data-testid="register-name"
          />
        </div>
        <div>
          <div className="eyebrow mb-1">E-Mail</div>
          <input
            className="field"
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid="register-email"
          />
        </div>
        <div>
          <div className="eyebrow mb-1">Passwort</div>
          <input
            className="field"
            type="password"
            minLength={12}
            maxLength={72}
            autoComplete="new-password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            data-testid="register-password"
          />
        </div>
        {error ? <p className="text-sm text-red-700" data-testid="register-error">{error}</p> : null}
        <button className="btn btn-primary w-full" disabled={busy} data-testid="register-submit">
          KONTO ANLEGEN
        </button>
      </form>
      <p className="mt-6 text-sm text-[var(--ink-soft)]">
        Schon ein Konto?{" "}
        <Link to="/login" className="font-semibold underline" data-testid="register-to-login">
          Anmelden
        </Link>
      </p>
    </div>
  );
}
